var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.013 336C320.013 415.406 255.419 480 176.013 480H114.606C63.669 480 18.606 447.531 2.481 399.188C-5.909 374.063 7.669 346.875 32.825 338.469C57.95 330.094 85.169 343.656 93.544 368.813C96.575 377.906 105.044 384 114.606 384H176.013C202.481 384 224.013 362.469 224.013 336S202.481 288 176.013 288H48.013C33.638 288 20.013 281.562 10.888 270.438C1.778 259.312 -1.878 244.688 0.95 230.594L32.95 70.594C37.434 48.156 57.138 32 80.013 32H240.013C266.528 32 288.013 53.5 288.013 80S266.528 128 240.013 128H119.356L106.559 192H176.013C255.419 192 320.013 256.594 320.013 336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.fb183a5f97d835c901c8d747895857a0.svg";
export { ForwardRef as ReactComponent };